var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66761V10.0009M10 13.3343H10.0083M16.5625 5.22596C17.1458 5.55763 17.5042 6.17846 17.5 6.84929V12.9193C17.5 13.5935 17.1308 14.2151 16.535 14.5426L10.91 18.101C10.6311 18.2541 10.3181 18.3343 10 18.3343C9.68186 18.3343 9.36887 18.2541 9.09 18.101L3.465 14.5426C3.17347 14.3833 2.9301 14.1486 2.76034 13.863C2.59058 13.5775 2.50067 13.2515 2.5 12.9193V6.84846C2.5 6.17429 2.86917 5.55346 3.465 5.22596L9.09 1.90929C9.37711 1.75099 9.69964 1.66797 10.0275 1.66797C10.3554 1.66797 10.6779 1.75099 10.965 1.90929L16.59 5.22596H16.5625Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShock);
export default __webpack_public_path__ + "static/media/Shock.3578c6538d8ac2011d9b9b4a3aa47bb4.svg";
export { ForwardRef as ReactComponent };